import { render } from "./AssetViewDetail.vue?vue&type=template&id=404e7b0c"
import script from "./AssetViewDetail.vue?vue&type=script&lang=js"
export * from "./AssetViewDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/Upwork/kaz/rana/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__